import React from "react";
import { CommonButton } from "./CommonButton";
import DailyRotationImage from "assets/svgIcons/PinsSideNav/DailyRotationIcon";
import { Badge, Tooltip } from "@mui/material";
import SettingsImage from "assets//svgIcons/SideNav/Settings";
import { CommonHeading } from "./CommonHeading";
import { FB_GLOBAL_STATES, MAP_GLOBAL_STATES } from "globalStore/globalStore";
import { useHookstate } from "@hookstate/core";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import OrderIcon from "assets/svgIcons/SideNav/FBIcon";
import {
  SideNavTabsWrapper,
  SubSideNavTabs,
} from "commonComponents/SideNav/subSideNav/subSideNavStyled";

export const FBSideNav = ({ pendingFoodOrderCountVal }) => {
  const { mapSideNavTabState } = useHookstate(MAP_GLOBAL_STATES);
  const { fbOrdersSettings } = useHookstate(FB_GLOBAL_STATES);
  const { t } = useTranslation();

  useEffect(() => {
    let getSubnavName = localStorage.getItem("mapSideNavTabState");
    if (
      getSubnavName == "Reports" ||
      getSubnavName === "Settings" ||
      getSubnavName === "Orders"
    ) {
      mapSideNavTabState.set(localStorage.getItem("mapSideNavTabState"));
    } else {
      mapSideNavTabState.set("Reports");
      localStorage.setItem("mapSideNavTabState", "Reports");
    }
  }, []);

  return (
    <div>
      <CommonHeading labelText={"F&B"} />
      <SideNavTabsWrapper>
        <SubSideNavTabs className="web-only-fb">
          <Tooltip title={t("Reports")} arrow>
            <span>
              <CommonButton
                labelText={"Reports"}
                displayText={"Reports"}
                changeSideNavData={() => {
                  localStorage.setItem("mapSideNavTabState", "Reports");
                  mapSideNavTabState.set("Reports");
                }}
              >
                <DailyRotationImage
                  color={
                    mapSideNavTabState.get() == "Reports"
                      ? "var(--theme-text)"
                      : "var(--text-secondary)"
                  }
                />
              </CommonButton>
            </span>
          </Tooltip>
          <Tooltip title={t("Settings")} arrow>
            <span>
              <CommonButton
                labelText={"Settings"}
                displayText={"Settings"}
                changeSideNavData={() => {
                  localStorage.setItem("mapSideNavTabState", "Settings");
                  mapSideNavTabState.set("Settings");
                }}
              >
                <SettingsImage
                  color={
                    mapSideNavTabState.get() == "Settings"
                      ? "var(--theme-text)"
                      : "var(--text-secondary)"
                  }
                />
              </CommonButton>
            </span>
          </Tooltip>
          {fbOrdersSettings.get().fillOrdersHere ? (
            <>
              <Badge
                badgeContent={
                  pendingFoodOrderCountVal !== 0
                    ? pendingFoodOrderCountVal
                    : null
                }
                color={pendingFoodOrderCountVal !== 0 ? "error" : "default"}
              >
                <Tooltip title={t("Orders")} arrow>
                  <span>
                    <CommonButton
                      labelText={"Orders"}
                      displayText={"Orders"}
                      changeSideNavData={() => {
                        localStorage.setItem("mapSideNavTabState", "Orders");
                        mapSideNavTabState.set("Orders");
                      }}
                    >
                      <OrderIcon
                        width={30}
                        // height={30}

                        color={
                          mapSideNavTabState.get() == "Orders"
                            ? "var(--theme-text)"
                            : "var(--text-secondary)"
                        }
                      />
                    </CommonButton>
                  </span>
                </Tooltip>
              </Badge>
            </>
          ) : (
            <></>
          )}
        </SubSideNavTabs>
      </SideNavTabsWrapper>
    </div>
  );
};
